var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-margin" }, [
    _c("div", { staticClass: "custom-card contact-card" }, [
      _c("div", { staticClass: "custom-card-content" }, [
        _c("div", { staticClass: "columns is-vcentered" }, [
          _c(
            "div",
            { staticClass: "column is-2 pr-0 pb-0" },
            [
              _c("b-icon", {
                staticClass: "pink",
                attrs: { icon: "question-circle", size: "is-large" }
              })
            ],
            1
          ),
          _c("div", { staticClass: "column pt-5 pl-0 pb-0" }, [
            _c("span", { staticClass: "area-title" }, [
              _vm._v(_vm._s(_vm.$t("projet.en-bref.une-question")))
            ])
          ])
        ]),
        _c("div", { staticClass: "columns is-vcentered" }, [
          _c("div", { staticClass: "column is-2 pr-0 pt-0" }),
          _c("div", { staticClass: "column pl-0 pt-0 column-card" }, [
            _c("div", { staticClass: "columns is-vcentered" }, [
              _c(
                "div",
                { staticClass: "column is-one-third" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "is-primary is-outlined is-rounded",
                      attrs: {
                        tag: "a",
                        target: "_blank",
                        href: "https://ame.ofb.fr/doku.php"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("projet.en-bref.wiki")) + " ")]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "column is-one-third" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "is-primary is-outlined is-rounded",
                      attrs: {
                        tag: "a",
                        target: "_blank",
                        href: "https://ame.ofb.fr/doku.php?id=sagafaq"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("projet.en-bref.faq")) + " ")]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "column is-one-third" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass:
                        "is-primary is-outlined is-rounded is-flex is-align-items-center is-justify-content-center",
                      staticStyle: { "padding-top": "9px" },
                      attrs: {
                        tag: "a",
                        target: "_blank",
                        href: "https://www.facebook.com/groups/804644174157988/"
                      }
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "bi bi-facebook",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "25",
                            height: "25",
                            fill: "currentColor",
                            viewBox: "0 0 16 16"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]),
    _c(
      "div",
      {
        staticClass: "custom-card mt-2 contact-card",
        staticStyle: { height: "210px", "margin-bottom": "50px" }
      },
      [
        _c("div", { staticClass: "custom-card-content" }, [
          _c("div", { staticClass: "columns is-vcentered" }, [
            _c(
              "div",
              { staticClass: "column is-2 pr-0 pb-0" },
              [
                _c("b-icon", {
                  staticClass: "pink",
                  attrs: { icon: "address-card", size: "is-large" }
                })
              ],
              1
            ),
            _c("div", { staticClass: "column pt-5 pl-0 pb-0" }, [
              _c("span", { staticClass: "area-title" }, [
                _vm._v(_vm._s(_vm.$t("projet.en-bref.contact")))
              ])
            ])
          ]),
          _c("div", { staticClass: "columns is-vcentered" }, [
            _c("div", { staticClass: "column is-2 pr-0 pt-0" }),
            _c("div", { staticClass: "column pl-0 pt-0 column-card" }, [
              _c("div", { staticClass: "columns" }, [
                _c("div", { staticClass: "column" }, [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.displayedContact.prenom) +
                        " " +
                        _vm._s(_vm.displayedContact.nom)
                    )
                  ]),
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t(_vm.displayedContact.profil)))
                  ]),
                  _c(
                    "p",
                    { staticClass: "mt-3 is-vcentered" },
                    [
                      _c("b-icon", {
                        staticClass: "pink",
                        staticStyle: { "padding-right": "5px" },
                        attrs: { icon: "phone", size: "is-medium" }
                      }),
                      _vm._v(" " + _vm._s(_vm.displayedContact.telephone) + " ")
                    ],
                    1
                  ),
                  _c("p", { staticClass: "is-vcentered" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          target: "_blank",
                          href: "mailto:" + _vm.displayedContact.courriel
                        }
                      },
                      [
                        _c("b-icon", {
                          staticClass: "pink",
                          staticStyle: { "padding-right": "5px" },
                          attrs: {
                            icon: "envelope-open-text",
                            size: "is-medium"
                          }
                        }),
                        _vm._v(
                          " " + _vm._s(_vm.displayedContact.courriel) + " "
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }